//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import Cookies from 'js-cookie'
import { getToken, setNickName, removeToken } from '@/utils/auth'
import { resolveMediaUrl, alternateMediaUrl } from '@/utils/mediaUrl'
import { isTrialAccount, TRIAL_PROFILE_LOCKED_TIP } from '@/utils/trialAccess'

const DEFAULT_AVATAR = require('@/assets/6_1_touxiang.png')

export default {
  name: 'ProfileEdit',
  data () {
    return {
      form: {
        nickName: '',
        phonenumber: '',
        sex: '0'
      },
      avatar: '',
      userId: null,
      saving: false,
      uploading: false,
      confirmShow: false,
      lockTip: TRIAL_PROFILE_LOCKED_TIP
    }
  },
  computed: {
    profileLocked () {
      return isTrialAccount(this.userId)
    },
    avatarUrl () {
      const path = (this.avatar || '').trim()
      if (!path) return DEFAULT_AVATAR
      return resolveMediaUrl(path)
    }
  },
  created () {
    this.loadProfile()
  },
  methods: {
    loadProfile () {
      this.$ajax.get(this.$api.userProfile).then(res => {
        if (!res) return
        const user = res.user || res
        this.userId = user.userId
        this.form.nickName = user.nickName || ''
        this.form.phonenumber = user.phonenumber || ''
        this.form.sex = user.sex || '0'
        this.avatar = (user.avatar || '').trim()
        if (user.nickName) setNickName(user.nickName)
      }).catch(() => {})
    },
    onAvatarError (e) {
      const el = e && e.target
      if (!el) return
      const alt = alternateMediaUrl(el.src)
      if (alt && el.dataset.avatarFallback !== '1') {
        el.dataset.avatarFallback = '1'
        el.src = alt
        return
      }
      el.onerror = null
      el.src = DEFAULT_AVATAR
    },
    goBack () {
      this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
    },
    triggerAvatarPick () {
      if (this.profileLocked) {
        this.$toast(this.lockTip)
        return
      }
      if (this.uploading) return
      this.$refs.avatarInput && this.$refs.avatarInput.click()
    },
    onAvatarChange (e) {
      if (this.profileLocked) return
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      if (!file.type.startsWith('image/')) {
        this.$toast('请选择图片文件')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$toast('图片不能超过 5MB')
        return
      }
      this.uploadAvatar(file)
    },
    uploadAvatar (file) {
      this.uploading = true
      const fd = new FormData()
      fd.append('avatarfile', file)
      axios.post('https://www.wordkillstu.com.cn/backend' + this.$api.userProfileAvatar, fd, {
        headers: {
          authorization: 'Bearer ' + getToken(),
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        const body = res.data || {}
        if (body.code !== 200) {
          this.$toast(body.msg || '上传失败')
          return
        }
        const imgUrl = (body.data && body.data.imgUrl) || body.imgUrl
        if (imgUrl) {
          this.avatar = imgUrl
          this.$toast('头像已更新')
        }
      }).catch(() => {
        this.$toast('上传失败，请重试')
      }).finally(() => {
        this.uploading = false
      })
    },
    saveProfile () {
      if (this.profileLocked) {
        this.$toast(this.lockTip)
        return
      }
      const nick = (this.form.nickName || '').trim()
      if (!nick) {
        this.$toast('请输入昵称')
        return
      }
      this.saving = true
      this.$ajax({
        method: 'put',
        url: this.$api.userProfile,
        data: {
          nickName: nick,
          phonenumber: this.form.phonenumber || '',
          sex: this.form.sex
        }
      }).then(() => {
        setNickName(nick)
        this.$toast('保存成功')
        setTimeout(() => this.$router.back(), 600)
      }).catch(() => {
        this.$toast('保存失败')
      }).finally(() => {
        this.saving = false
      })
    },
    goChangePassword () {
      if (this.profileLocked) {
        this.$toast(this.lockTip)
        return
      }
      this.$router.push('/updatePassword')
    },
    logoff () {
      this.confirmShow = true
    },
    onConfirmLogout () {
      removeToken()
      Cookies.remove('NickName')
      this.$router.push('/sysLogin_display')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/sys/profileEdit.vue